import { Column as ActionTypes } from '../actionTypes';

const initialState = [];

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.Add:
      return state.find(e => e.Table === action.payload.Table) ? state : [...state, action.payload];
    case ActionTypes.Remove:
      return state.filter(e => e.Table !== action.payload.Table);
    default:
      return state;
  }
};
